// extracted by mini-css-extract-plugin
export var label = "_gb-2";
export var slideContainer = "_gb-0";
export var slider = "_gb-1";